import React from 'react';
import Card from './Card.js';
import '../App.css';
import { getEffectiveScale, getUILoc } from '../utils/cardUtils.js';
import audioManager from '../utils/AudioManager.js';

const Hand = ({ player, onPlayCard, onProvideInput, awaiting_input, onCardClick, gameState }) => {
    if (!player) return <div className="hand">{getUILoc('MESSAGES.LOADING')}</div>;

    // プレイヤーの現在の実効規模を計算
    const currentScale = getEffectiveScale(player, gameState);

    const handleClick = (card) => {
        if (onCardClick) {
            audioManager.playSE('select');
            onCardClick(card);
        } else {
            if (!awaiting_input) {
                onPlayCard(card);
            }
        }
    };

    return (
        <div className="hand">
            <h4>{getUILoc('MESSAGES.PLAYER_HAND', { name: player.name, count: player.hand.length })}</h4>
            <div className="hand-cards-scrollable">
                {player.hand.map(card => {
                    let isCardSelectable = false;
                    if (awaiting_input) {
                        if (awaiting_input.type === 'CHOICE_CARD_FOR_EFFECT') {
                            isCardSelectable = awaiting_input.valid_target_ids && awaiting_input.valid_target_ids.includes(card.instance_id);
                        } else if (awaiting_input.type === 'CHOICE_CARDS_FOR_OPERATION') {
                            isCardSelectable = awaiting_input.options && awaiting_input.options.some(option => option.instance_id === card.instance_id);
                        }
                    }

                    // 規模不足判定
                    const isInsufficientScale = currentScale < card.required_scale;

                    return (
                        <div key={card.instance_id} className="hand-card-slot" onClick={() => handleClick(card)}>
                            <Card 
                                card={card} 
                                mode="game" 
                                isSelectable={isCardSelectable} 
                                location="hand" 
                                isInsufficientScale={isInsufficientScale}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Hand;
